import { render, staticRenderFns } from "./dealSaleRewardDialog.vue?vue&type=template&id=17a61bf4&scoped=true"
import script from "./dealSaleRewardDialog.vue?vue&type=script&lang=js"
export * from "./dealSaleRewardDialog.vue?vue&type=script&lang=js"
import style0 from "./dealSaleRewardDialog.vue?vue&type=style&index=0&id=17a61bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a61bf4",
  null
  
)

export default component.exports